/* hs-eslint ignored failing-rules */
/* eslint-disable hubspot-dev/prefer-hubspot-url-utils */

export const BOOKING_VIRAL_HUBS_CTA = 'booking-page-signup-visual';
export const THANKYOU_VIRAL_HUBS_CTA = 'thank-you-page-signup-visual';
export const wrongHubSpotDomain = 'www.hubspot.com';
export const wrongHubSpotQADomain = 'www.hubspotqa.com';
export const hubSpotDomain = 'app.hubspot.com';
export const hubSpotQADomain = 'app.hubspotqa.com';